import axios from 'axios';
import store from '../../store/index';

export default {
	saveLocale(localeKey) {
		return axios.patch(`/api/users/me/`, { locale: localeKey });
	},

	saveProductionBanner(enabled) {
		return axios.patch(`/api/users/me/`, { showProductionBanner: enabled });
	},

	getUserLocale() {
		return axios.get('/api/users/me');
	},
};
